export class SurveyResult {
  public constructor(initializer?: Partial<SurveyResult>) {
    Object.assign(this, initializer);
  }

  public hash: string | undefined;
  public id: number | undefined;
  public result: number | undefined;
}
